import { DatePipe } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { TranslocoModule } from '@ngneat/transloco';
import { LatLng } from 'leaflet';
import { GeopositionMapComponent } from '../geoposition-map.component';
import { GeopositionMarkerData, GeopositionSummary, WorkdayGeopositionMarkerData, WorkdayReferenceGeopositionMarkerData } from '../../../../modules/admin/tasks/tasks.types';

@Component({
    selector: 'app-workday-geoposition-map',
    imports: [MatIcon, TranslocoModule, DatePipe],
    templateUrl: './workday-geoposition-map.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './workday-geoposition-map.component.scss'
})
export class WorkdayGeopositionMapComponent extends GeopositionMapComponent<WorkdayGeopositionMarkerData> {
    @Input() referenceGeopositionSummaryList: WorkdayReferenceGeopositionMarkerData[] = [];
    @Input() initialMapCenterPosition: LatLng | undefined;

    protected referenceIconName = "position-marker-0";

    protected defaultCenter(): void {
        if (this.initialMapCenterPosition?.lat !== undefined && this.initialMapCenterPosition?.lng !== undefined) {
            this.centerMap(this.initialMapCenterPosition.lat, this.initialMapCenterPosition.lng);
        } else {
            super.defaultCenter();
        }
    }

    protected addMarkers() {
        if (this.geopositionSummaryList && this.geopositionSummaryList.length > 0) {
            this.geopositionSummaryList.forEach((geopositionSummary, index) => {
                this.addMarker(geopositionSummary, this.iconNames[index]);
                this.addMarker(this.referenceGeopositionSummaryList[index], this.referenceIconName);
            })
        }
    }

    protected removeInvalidGeopositionSummary() {
        if(!this.geopositionSummaryList) return;

        const indicesToKeep = this.geopositionSummaryList
            .map((g, i) => g.latitude && g.longitude ? i : -1)
            .filter(i => i !== -1);

        this.geopositionSummaryList = indicesToKeep.map(i => this.geopositionSummaryList[i]);
        this.referenceGeopositionSummaryList = indicesToKeep.map(i => this.referenceGeopositionSummaryList[i]);
    }

    goToMarker(num: number) {
        let geoposition: GeopositionSummary

        if (num % 2 !== 0) {
            geoposition = this.referenceGeopositionSummaryList[Math.floor(num / 2)];
        } else {
            geoposition = this.geopositionSummaryList[num / 2];
        }
        if (geoposition) {
            this.centerMap(geoposition.latitude, geoposition.longitude);
        }
    }

    getLatLngDisplay(geopositionMarkerData: GeopositionMarkerData): string {
        return "(" + parseFloat(geopositionMarkerData.latitude.toFixed(4)) + ", " + parseFloat(geopositionMarkerData.longitude.toFixed(4)) +  ")";
    }
}